<template>
  <unlockComponent v-if="status == 'notPurchased'" :unlockDetails="vikingUnlock" :paramValue="'Viking-Upgrade'"/>
  <!-- <div v-else class="viking-status-bg-row">
    <div class="w-full h-full flex flex-col items-center relative">
      <div class="cover-image"></div>
      <div class="absolute d-flex flex-row items-center top-0 left-0 pl-6 pt-6">
        <feather class="h-5 w-5 text-white cursor-pointer mr-2" type="chevron-left" />
        <router-link to="/dashboard">
          <p class="text-white font-semibold leading-normal my-0">Back to Home</p>
        </router-link>
      </div>
      <div
        class="viking-status-info-container m-auto bg-white rounded shadow-key-hover z-10 max-w-lg"
      >
        <div
          class="bg-cobalt-50 px-6 rounded-t flex items-center text-cobalt-500 text-sm font-semibold status-info-header-container"
        >
          <feather type="info" class="h-5 w-5 fill-current mr-2" />
          <span> {{ thing.title }}</span>
        </div>
        <div class="p-6 error-container-status-viking" v-html="thing.description" />

        <div v-if="thing.linkText" class="p-6 pt-0 flex">
          <router-link
            :to="thing.linkTarget($store.getters.profile.barcode)"
            class="bg-cobalt-500 text-white font-semibold px-6 py-4 rounded"
          >
            <span class="text-white">{{ thing.linkText }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div> -->
  <div v-else class="container d-flex flex-column align-items-center justify-content-center">
      <div class="col-md-10 col-lg-9 col-xl-8 m-5 mx-auto">
          <div class="card mb-3 rounded-4 overflow-hidden">
              <div class="row g-0">
                  <div class="col-sm-5 d-flex align-items-end position-relative overflow-hidden">
                      <div class="bg-gradient-circle position-absolute z-0 w-75 h-100"></div>
                      <img :src="doctor" class="img-fluid mt-5 mx-auto z-1"
                          alt="Health">
                  </div>
                  <div class="col-sm-7">
                      <div
                          class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
                          <h5 class="card-title text-start my-3" v-if="thing.title">{{ thing.title }}</h5>
                          <!-- <p class="card-text text-start">{{ details.heading }}</p> -->
                          <p class="card-text text-start">
                              <small class="text-muted" v-html="thing.description"></small>
                          </p>
                          <router-link v-if="thing.linkText" :to="thing.linkTarget($store.getters.profile.barcode)">
                              <button class="btn btn-primary">{{ thing.linkText }}</button>
                          </router-link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<style lang="scss" scoped>
.bg-gradient-circle {
  background: url('@/assets/gradient-circle.png') no-repeat;
  background-position: right;
  // background-size: cover;
}

img {
  max-height: 330px;
}
</style>
<script>
import "@/styles/layout/statusDialog.scss";
import unlockComponent from "@/components/upgrade/UnlockComponent.vue";
import { ref, onMounted } from "vue";
import { mapGetters } from "vuex";
import { getVikingUnlock } from "@/services/vikings.js";
import doctor from "@/assets/characters/blood-test-inspiration-new.png";

const dictionary = {
  transferQcFailed: {
    title: "We've encountered an error",
    description:
      "An issue has occurred in retrieving DNA information from your upload. Please reupload your data by clicking the button below",
    linkText: "Reupload",
    linkTarget: (barcode) => ({
      name: "reupload-dna",
      params: {
        barcode,
      },
    }),
  },
  loadingFailed: {
    title: "Something went wrong loading the page",
    description: "Please refresh to try again or contact support if the issue persists",
  },
  testErrored: {
    title: "Something went wrong processing your test",
    description: "Please see the home for more information",
    linkText: "Home",
    linkTarget: () => ({
      name: "dashboard",
    }),
  },
  testFailed: {
    title: "Something went wrong processing your test",
    description: "Please see the home for more information",
    linkText: "Home",
    linkTarget: () => ({
      name: "dashboard",
    }),
  },
  resultPending: {
    title: "Your results are currently being processed",
    description:
      "Please check back later, you will receive an email when your results have finished processing",
  },
  testNoData: {
    title: "Something went wrong processing your test",
    description: "Please see the home for more information",
    linkText: "Home",
    linkTarget: () => ({
      name: "dashboard",
    }),
  },
  notPurchased: {
    title: "What will you discover?",
    description: "Upgrade your kit to reveal your genetic similarity to vikings",
    linkText: "Purchase viking upgrade",
    linkTarget: () => ({
      path: "/store/Viking-Upgrade",
    }),
  },
};

/**
 * @param {string} value
 */
function validatePropValue(value) {
  const allowedValues = Object.keys(dictionary);
  return allowedValues.includes(value);
}
export default {
  name: "viking-status",
  props: {
    status: {
      required: true,
      type: String,
      validator: validatePropValue,
    },
  },
  setup() {
    const vikingUnlock = ref(null); // Define vikingUpgrade as a ref

    onMounted(async () => {
      vikingUnlock.value = await getVikingUnlock();
    });

    return {
      vikingUnlock,
      doctor
    };
  },
  computed: {
    ...mapGetters(["isUploader"]),
    thing() {
      return dictionary[this.status];
    },
  },
  components: { unlockComponent },
};
</script>
